<template>
    <div>
        <div class="position-relative">
            <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-12">
                                <h1 class="display-3  text-white">Data Collection
                                </h1>
                                <p class="lead  text-white">Data is the most critical element to realize enterprise intelligence. Enterprises usually collect various types of data from internal product and service environments. At present, most machine learning algorithms require enterprises to collect huge amounts of data, and maintain a professional data collection team like this. An enterprise is an expensive expense. The intelligent data collection service in the picture can greatly reduce the cost of enterprise data collection. We have a high-quality data collection team and professional collection technology, and have partners in many countries around the world to meet the wide range of data collection needs of customers.</p>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-notification-70" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">On-site collection</h6>
                                    <p class="description mt-3">On-site data collection is suitable for some projects with special requirements (such as specific microphones or cameras). We have data collection partners all over the world, which can record on different sites (such as cars, factories, sports venues, squares, banquets, etc.) data.</p>
                            
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-mobile-button" type="success" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-success text-uppercase">Telephone collection</h6>
                                    <p class="description mt-3">Telephone collection is suitable for the collection of text and voice data. Our telephone recording system can obtain one or more telephone conversations from participants in different languages ​​and different regions to complete the collection of raw data.</p>
                                  
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-world" type="warning" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-warning text-uppercase">Remote collection</h6>
                                    <p class="description mt-3">Remote collection is suitable for companies that need to collect a large amount of data in a short time. We quickly collect data needed by customers from proprietary partners or their databases around the world. We can quickly obtain it to satisfy enterprise's needs.</p>
                                    
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">What kind of data we collect?</h2>
                    
                    </div>
                </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-lg-6 order-lg-1">
                       
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-image" gradient="success" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-success">Image</h5>
                                    <p>Customized image data collection for enterprises, unique on-site combined with remote collection methods, covering different scenarios including face, body, transportation, goods, documents, etc. collection.</p>
                                </div>
                            </div>
                        </card>
                         <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-collection" gradient="primary" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-primary">Text</h5>
                                    <p>Collect natural language text data for enterprises, covering social, business, scientific research, entertainment and etc. Collection types include news, blogs, forums, commercial marketing, academic research, etc.</p>
                                </div>
                            </div>
                        </card>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                         <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-camera-compact" gradient="warning" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-warning">Video</h5>
                                    <p>Collect customized video data for enterprises, covering different scenarios including human activities, traffic patterns, commercial operations, sports competitions and other scenarios.</p>
                                    
                                </div>
                            </div>
                        </card>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-sound-wave" gradient="danger" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-danger">Audio</h5>
                                    <p>Collect customized voice data for enterprises, covering dozens of languages ​​and dialects services, covering different collection scenarios (such as cars, indoors, public places, recording studios, parties, private spaces, etc.)</p>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>

       <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <card gradient="secondary" shadow body-classes="p-lg-5">
                            <h4 class="mb-1">Interested in data collection service?</h4>
                            <p class="mt-0">Your feedback is very important to us.</p>
                            <base-input class="mt-5"
                                        alternative
                                        placeholder="Your name"
                                        v-model="form.name"
                                        addon-left-icon="ni ni-single-02">
                            </base-input>
                            <base-input alternative
                                        placeholder="Email address"
                                        v-model="form.email"
                                        addon-left-icon="ni ni-email-83">
                            </base-input>
                            <base-input alternative
                                        placeholder="Phone number"
                                        v-model="form.phone"
                                        @input="phoneNumber"
                                        addon-left-icon="ni ni-mobile-button">
                            </base-input>
                            <base-input alternative
                                        placeholder="Company name"
                                        v-model="form.company"
                                        addon-left-icon="ni ni-building">
                            </base-input>
                            <base-input class="mb-4">
                                <textarea 
                                    class="form-control form-control-alternative" 
                                    name="name"
                                    rows="4"
                                    cols="80" 
                                    placeholder="Type a message..."
                                    v-model="form.message">
                                </textarea>
                            </base-input>
                             <small class="text-light">{{indicator}}</small>
                            <base-button type="primary" round block @click="sendMessage">
                                Send Message
                            </base-button>
                        </card>
                    </div>
                </div>
            </div>
        </section>
        
    </div>
</template>

<script>
import axios from 'axios'
export default {
  name: "data-collection",
  components: {
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone: '',
        company: '',
        message: ''
      },
      interest_string: '0000001000',
      indicator:''
    };
  },
  methods: {
    isValidateEmail: function() {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(this.form.email);
    },
    isValidatePhone: function() {
        if (this.form.phone != "") {
            return this.form.phone.match(/\d/g).length===10;
        }
        return false;
    },
    phoneNumber() {
    	var x = this.form.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.form.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    },
    async sendMessage(){
        this.indicator = "Sending message..."
        if (this.form.name === "") {
            this.indicator = "Please input your name!"
            return
        }
        if (this.isValidateEmail() === false) {
            this.indicator = "Please input a valid email address!"
            return
        }
        if (this.isValidatePhone() === false) {
            this.indicator = "Please input a valid phone number!"
            return
        }
        if (this.form.company === "") {
            this.indicator = "Please input your company name!"
            return
        }
        if (this.form.message === "") {
            this.indicator = "Please input your message!"
            return
        }
      
        axios.post('/feedback', {
            'Name': this.form.name,
            'Phone': this.form.phone,
            'Email': this.form.email,
            'Company': this.form.company,
            'Interest': this.interest_string,
            'Message': this.form.message
        })
        .then((response) => {
        
            if (response.status === 200 && response.data != null) {
            switch (response.data.code){
                case 200:
                    this.indicator = "We have received your message and will contact you as soon as possible！"
                    this.form.name = ""
                    this.form.company = ""
                    this.form.email = ""
                    this.form.phone = ""
                    this.form.message = ""
                    break
                default:
                    this.indicator = "Sever error, please try again later！"
            }
            }
        })
        .catch( error => {
            this.indicator = "Sever error, please try again later！"
        })
    }	
  }
};
</script>